<template>
  <div class="view-container">
    <div class="extended-filter-block">
      <h2>Развитие</h2>
      <div class="extended-search-block-mobile">
        <div class="search-outline-block">
          <SearchOutlined @click="showMobileFilterModal = true" style="color: rgba(0, 0, 0, 0.45)" />
          <div v-if="currentFiltersLine" class="dot"></div>
        </div>
      </div>
    </div>

    <div class="card">
      <a-table
               ref="summaryTableRef"
               class="product-course-table"
               :columns="getExtendedColumns('courses', 'Развитие')"
               rowKey="id" :data-source="tableData.courses?.children ?? []"
               :scroll="summaryTableScroll"
               :pagination="false"
               :locale="{ emptyText: emptySlot()}"
               :table-layout="'fixed'"
               :loading="summaryIsLoading"
      >
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'validUntil'">
            <a-popover
                v-if="hasMultipleOrderDates(record)"
                placement="topRight"
                overlayClassName="order-expiration-popover"
            >
              <template #content>
                <OrderExpirationListTable :orders="record?.orders ?? []" />
              </template>

              <span class="expiration-date-cell expiration-date-cell--interactive">
                <span>{{ record.validUntil }}</span>
                <ClockCircleOutlined
                    v-if="record.timeRemaining && record.timeRemaining < 30"
                    class="circle-clock"
                    :style="{ color: '#FAAD14' }"
                />
              </span>
            </a-popover>

            <span v-else class="expiration-date-cell">
              <span>{{ record.validUntil }}</span>
              <ClockCircleOutlined
                  v-if="record.timeRemaining && record.timeRemaining < 30"
                  class="circle-clock"
                  :style="{ color: '#FAAD14' }"
              />
            </span>
          </template>

          <template v-else>
            {{ text }}
          </template>
        </template>
      </a-table>
      <div class="order-button">
        <a-button class="secondary-button" @click="showOrderForm = true">
          Заказать продукт
        </a-button>
      </div>
    </div>

    <div class="card card__with-action card__with_smaller_table">
      <div class="action-block upper-block">
        <div class="action-select-wrapper">
          <a-select
              v-model:value="currentGroup"
              :placeholder="'Выберите группу'"
              style="width: 100%;"
              @change="updateFilters"
              :not-found-content="'Нет данных'"
          >
            <a-select-option :key="'all'" :value="'all'">
              Все сотрудники
            </a-select-option>
            <a-select-option v-for="e in groups" :key="e.id" :value="e.id">
              {{ e.name }}
            </a-select-option>
          </a-select>
        </div>
        <div class="action-select-wrapper">
          <a-select
              v-model:value="currentProduct"
              :placeholder="'Курс'"
              style="width: 100%;"
              @change="updateFilters"
              :not-found-content="'Нет данных'"
          >
            <a-select-option :key="'all'" :value="'all'">
              Все курсы
            </a-select-option>
            <a-select-option v-for="e in tableData.courses?.children" :key="e.id" :value="e.id">
              {{ e.product }}
            </a-select-option>
          </a-select>
        </div>
        <div class="table-redirect-button">
          <a-button class="secondary-button" @click="setSpecialDetailRouteAndRedirect">
            Сводная таблица
          </a-button>
        </div>
      </div>

      <TableHorizontalScrollShell ref="tableShell">
        <a-table
            ref="tableRef"
            rowKey="id"
            :columns="columns"
            :data-source="staff"
            :scroll="tableScroll"
            :row-selection="{ selectedRowKeys: selectedUsers, onChange: onSelectChange, columnWidth: 40 }"
            :pagination="false"
            :loading="tableLoading"
            @change="handleTableChange"
            :table-layout="'fixed'"
            :expandedRowKeys="expandedRowKeys"
            :expandable="expandableConfig"
            :expandIconAsCell="false"
            :expandIconColumnIndex="-1"
            :expandRowByClick="false"
        >

          <template #bodyCell="{ column, text, record }">
            <template v-if="column.dataIndex === 'name'">
              <a class="user-link" @click="router.push(`/staff/${record.id}/edit`)">{{ text }}</a>
            </template>

            <template v-if="column.dataIndex === 'groups'">
              <a-tag v-for="(group) in record.groups" :key="group.id">
                {{ group.name }}
              </a-tag>
            </template>

            <template v-if="column.dataIndex === 'expires_at'">
              <span>
                {{ record.instruments.closest_expiration ?? '' }}
              </span>
            </template>

            <template v-if="column.dataIndex === 'last_activity'">
              <span>
                {{ record.last_activity ?? '' }}
              </span>
            </template>

            <template v-if="column.dataIndex === 'tracker'">
              <a-tag color="green" v-if="record.instruments.tracker.has_access">
                Выдан
              </a-tag>
              <a-tag v-else>
                Не выдан
              </a-tag>
            </template>

            <template v-if="column.dataIndex === 'diary'">
              <a-tag color="green" v-if="record.instruments.diary.has_access">
                Выдан
              </a-tag>
              <a-tag v-else>
                Не выдан
              </a-tag>
            </template>

            <template v-if="column.dataIndex === 'settings'">
              <a-dropdown :trigger="['click']" placement="bottomLeft">
                <a-button type="text" @click.prevent>
                  <MenuOutlined />
                </a-button>

                <template #overlay>
                  <a-menu @click="({key}) => handleAction(key, record)">
                    <a-menu-item key="remind">Напомнить</a-menu-item>
                    <a-menu-item key="manage_access">Управлять доступами</a-menu-item>
                    <a-menu-item key="export">Экспортировать</a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </template>
          </template>

          <template #expandedRowRender="{ record }">
            <a-table
                class="inner-table"
                :columns="subColumns"
                :data-source="record.courses"
                :pagination="false"
                size="small"
                rowKey="external_id">

              <template #bodyCell="{column, text, record }">
                <template v-if="column.dataIndex === 'name'">
                  <div>
                    <span>
                      {{ record.name }}
                    </span>
                  </div>
                </template>

                <template v-if="column.dataIndex === 'status'">
                  <a-tag color="green" v-if="record.status === 'finished'">
                    Завершен
                  </a-tag>
                  <a-tag class="yellow-tag" v-else-if="record.status === 'new'">
                    Не начат
                  </a-tag>
                  <a-tag v-else-if="record.is_expired" class="red-tag">
                    В процессе
                  </a-tag>
                  <a-tag  v-else class="blue-tag">
                    В процессе
                  </a-tag>
                </template>

                <template v-if="column.dataIndex === 'percent_completed'">
                  <div class="course-progress">
                    <a-progress :stroke-color="'#21AC0C'" :percent="text ?? 0" :format="percent => `${percent}%`" />
                  </div>
                </template>
              </template>
            </a-table>
          </template>

          <template #emptyText>
            <div class="no-data-wrapper">
              <img :src="NotFoundIcon" class="no-data-image" alt="Нет результатов"/>

              <div class="no-data-text">
                {{
                  currentFiltersLine
                      ? 'Нет данных для отображения. Измените фильтры или запрос.'
                      : 'Нет данных для отображения. Добавьте сотрудников, чтобы начать работу.'
                }}
              </div>

              <a-button
                  v-if="currentFiltersLine"
                  @click="resetFilters"
              >
                <template #icon>
                  <ReloadOutlined />
                </template>
                Сбросить фильтры
              </a-button>
            </div>
          </template>
        </a-table>
      </TableHorizontalScrollShell>

      <div class="bottom-container">
        <div class="action-block" v-if="!isMobile || isMobile && selectedUsers.length">
          <div class="action-select-wrapper" >
            <a-select
                v-model:value="actionToApply"
                :placeholder="'Выберите действие'"
                style="width: 100%;"
                @change="() => handleAction(actionToApply)"
                :not-found-content="'Нет данных'"
                :disabled="!selectedUsers.length"
            >
              <a-select-option v-for="e in actions" :key="e.id" :value="e.id">
                {{ e.name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <a-pagination v-model:current="currentPage"
                      :page-size="entitiesPerPage"
                      :buildOptionText="(count) => `${count.value} / стр`"
                      :show-total="isMobile ? undefined : (total => `Всего ${total ?? 0} элементов`)"
                      :total="totalUsers"
                      :show-less-items="isMobile"
                      @change="handlePageChange"
        />
      </div>
    </div>

    <ManageAccessForm
        :open="currentAction === 'manage_access'"
        v-if="currentAction === 'manage_access'"
        @close="clearCurrentUserAndAction"
        @submitted="() => {
          clearCurrentUserAndAction();
          fetchAfterSubmit();
        }"
        @showStaff="() => router.push('/staff')"
        @showOrderForm="() => {
              clearCurrentUserAndAction();
              showOrderForm = true;
            }"
        :userData="currentActionUser?.id ? [currentActionUser.id] : selectedUsers"
        :name="currentActionUser?.id ? currentActionUser.name : null"
        :mode="'staff'"
    />

    <UsersFilterMobileForm
        v-if="showMobileFilterModal"
        :open="showMobileFilterModal"
        @close="showMobileFilterModal = false"
        :groups="groups"
    />

    <NewOrderForm
        v-if="showOrderForm"
        :open="showOrderForm"
        :initial-open-tables="['courses']"
        @close="showOrderForm = false"
    />
  </div>
</template>


<script>
import {onBeforeMount, reactive, ref, watch} from "@vue/runtime-core";
import {h} from "vue";
import NotFoundIcon from "@/assets/images/icons/no_data.svg";
import {useStore} from "vuex";
import {onBeforeRouteLeave, useRoute, useRouter} from "vue-router";
import {computed} from "@vue/reactivity";
import {
  SearchOutlined,
  SettingOutlined,
  PlusOutlined,
  ReloadOutlined,
  MenuOutlined,
  DownOutlined,
  ClockCircleOutlined,
  InfoCircleOutlined
} from '@ant-design/icons-vue'
import ManageAccessForm from "@/components/Forms/Access/ManageAccessForm.vue";
import NewOrderForm from "@/views/Orders/OrderForm.vue";
import UsersFilterMobileForm from "@/feature/users/UsersFilterMobileForm.vue";
import {getWordFormBasedOnTheCount} from "../Report/utils";
import {message} from "ant-design-vue";
import {useTableColumns} from "@/mixins/useTableColumns";
import { TABLE_SCROLL_Y, useTableScroll } from "@/mixins/useTableScroll";
import TableHorizontalScrollShell from "@/components/Tables/TableScrollComponent.vue";
import OrderExpirationListTable from "@/components/Tables/OrderExpirationListTable.vue";
import useBreakpoints from "@/mixins/useBreakpoints";
import {setSpecialStaffFromRoute} from "@/utils/specialStaffRoute";

export default {
  name: 'new-groups',
  methods: {getWordFormBasedOnTheCount},
  components: {
    OrderExpirationListTable,
    TableHorizontalScrollShell,
    ClockCircleOutlined,
    UsersFilterMobileForm,
    NewOrderForm,
    ManageAccessForm,
    InfoCircleOutlined,
    SearchOutlined, SettingOutlined, PlusOutlined, ReloadOutlined, MenuOutlined, DownOutlined},
  setup() {

    const store = useStore(),
        router = useRouter(),
        route = useRoute();

    setSpecialStaffFromRoute(store, route);

    const showOrderForm = ref(false);
    const actionToApply = ref();
    const showActionModal = ref();
    const currentAction = ref();
    const modalActionLoading = ref(false);
    const tableLoading = ref(true);
    const groupsLoading = ref(true);
    const statusError = ref({
      groupName: null,
    });

    const actionButtonLabels = {
      copy: 'Копировать',
      delete: 'Удалить',
      merge: 'Объединить',
      create: 'Создать'
    }

    const showMobileFilterModal = ref(false);
    const specialStaff = computed(() => store.state.users.specialStaff);
    const blockedStaff = computed(() => store.state.users.showBlocked);
    const hidePagination = ref(false);

    const allGroups = computed(() => store.state.group.groups);
    const groups = ref([]);

    const manageGroupAccessUsers = ref([]);

    const selectedUsers = ref([]);
    const currentActionUser = ref({
      id: null,
      name: '',
      groups: [],
    });

    const showFilterModal = ref(false);
    const entitiesPerPage = ref(10);
    const currentPage = ref(1);
    const filtersPopoverOpen = ref(false);
    const currentProduct = ref('all');

    const getShortListColumns = (key, mainTitle) => {
      return [
        {
          title: mainTitle,
          dataIndex: 'product',
          key: 'product',
          width: 550,
          align: 'left',
        },
        {
          title: 'Доступ',
          dataIndex: 'has_access',
          key: 'has_access',
          width: 70,
          align: 'right',
        },
        {
          title: 'Истекает',
          dataIndex: 'validUntil',
          key: 'validUntil',
          width: 100,
          align: 'center',
        },
      ];
    }

    const initialColumns = ref([
      {
        title: 'Сотрудник',
        dataIndex: 'name',
        sorter: true,
        visible: true,
        width: 450,
      },
      {
        title: 'Должность',
        dataIndex: 'job_title',
        sorter: true,
        visible: true,
        width: 250,
      },
      {
        title: 'Группы',
        dataIndex: 'groups',
        visible: true,
        width: 400,
      },
      {
        title: 'Последний вход',
        dataIndex: 'online_from',
        sorter: true,
        visible: true,
        width: 250,
      },
    ]);

    const staff = computed(() => store.state.users.staffWithProducts);

    const { columns, scrollX, scrollY, tableRef, tableScroll, updateTableYScroll } = useTableColumns(initialColumns, {
      tableKey: 'courses',
      settingsWidth: 40,
      selectionWidth: 40,
      dataSource: staff,
      scrollYSize: TABLE_SCROLL_Y.twoCards,
    });

    const actions = [
      {
        id: 'remind',
        name: 'Отправить напоминание'
      },
      {
        id: 'manage_access',
        name: 'Управлять доступами'
      },
      {
        id: 'export',
        name: 'Экспортировать'
      },
    ];

    const filters = computed(() => store.state.users.filters);
    const currentFiltersLine = computed(() => store.state.users.filterString);
    const companyActivityData = computed(() => store.state.companyActivity);

    const totalUsers = computed(() => store.state.users.staffWithProductsTotal);
    const currentGroup = ref('all');

    const tableData = reactive({
      courses: []
    });
    const summaryTableData = computed(() => tableData.courses?.children ?? []);
    const {
      tableRef: summaryTableRef,
      tableScroll: summaryTableScroll,
    } = useTableScroll({
      scrollX: 780,
      dataSource: summaryTableData,
      scrollY: TABLE_SCROLL_Y.small,
    });

    const emptySlot = () =>
        h('div', { class: 'no-data-wrapper' }, [
          h('img', { src: NotFoundIcon, class: 'no-data-image'}),
          h('div', {class: 'no-data-text'}, 'Нет данных для отображения'),
        ]);

    const summaryIsLoading = ref(false);

    const hasMultipleOrderDates = (record) => record?.orders && record?.orders.length > 1;

    const prepareProducts = () => {
      let courseActivitySummary = companyActivityData.value?.courses?.total_counts ? getCourseActivitySummary(companyActivityData.value?.courses?.total_counts) : [];

      tableData.courses = {
            id: 2,
            product: 'Развитие',
            purchased: courseActivitySummary?.purchased ?? 0,
            issued: courseActivitySummary?.issued ?? 0,
            remaining: courseActivitySummary?.remaining ?? 0,
            completed: courseActivitySummary?.completed ?? 0,
            validUntil: courseActivitySummary?.validUntil ?? null,
            timeRemaining: courseActivitySummary?.timeRemaining ?? null,
            children: courseActivitySummary?.children ?? null,
      }
    }

    const getCourseActivitySummary = (data) => {
      let total = data.find((el) => el.external_id === 'all');

      return {
        purchased: (total?.issued_users_count + total?.free_count),
        issued: total?.issued_users_count,
        remaining: total?.free_count,
        completed: total?.finished_count,
        validUntil: total?.closest_expiring_date,
        timeRemaining: total?.remaining_active_days,
        children: getSubCourseProducts(data),
      }
    }

    const getSubCourseProducts = (array) => {
      let subProductsArray = array.filter((el) => el.external_id !== 'all').map((el) => {
        return {
          product: el.name,
          id: el.external_id,
          purchased: el.all_count,
          issued: el.issued_users_count,
          remaining: el.free_count,
          completed: el.finished_count,
          validUntil: el.expiration_date,
          timeRemaining: el.remaining_active_days > 0 ? el.remaining_active_days : null,
          orders: el.orders ?? [],
        }
      });

      if (!subProductsArray || !subProductsArray.length) {
        return null;
      }

      return subProductsArray;
    }

    const getExtendedColumns = (key, mainTitle) => {
      return [
        {
          title: mainTitle,
          dataIndex: 'product',
          key: 'product',
          width: 110,
          align: 'left',
        },
        {
          title: 'Куплено',
          dataIndex: 'purchased',
          key: 'purchased',
          width: 60,
          align: 'right',
        },
        {
          title: 'Выдано',
          dataIndex: 'issued',
          key: 'issued',
          width: 60,
          align: 'right',
        },
        {
          title: 'Осталось',
          dataIndex: 'remaining',
          key: 'remaining',
          width: 60,
          align: 'right',
        },
        {
          title: 'Завершено',
          dataIndex: 'completed',
          key: 'completed',
          width: 60,
          align: 'right',
        },
        {
          title: 'Истекает',
          dataIndex: 'validUntil',
          key: 'validUntil',
          width: 45,
          align: 'right',
        },
      ]
    }

    const onSelectChange = selectedRowKeys => {
      selectedUsers.value = selectedRowKeys;
    };

    // фильтры
    const openFilterModal = () => {
      showFilterModal.value = true;
    }

    const updateFilters = () => {
      filtersPopoverOpen.value = false;
      showMobileFilterModal.value = false;

      currentPage.value = 1;
      fetchUsers();
    }

    const clearCurrentUserAndAction = () => {
      currentAction.value = '';
      actionToApply.value = null;
      showActionModal.value = false;
      currentActionUser.value = {
        id: null,
        name: '',
        groups: [],
      }
    }

    const handleAction = (action, userObject = null) => {
      if (userObject) {
        currentActionUser.value.id = userObject.id;
        currentActionUser.value.groups = userObject.groups.map((group) => group.id);
        currentActionUser.value.name = userObject.name;
      } else {
        currentActionUser.value = {
          id: null,
          name: '',
          groups: [],
        }
      }

      if (action === 'remind') {
        remindAboutPassing();
        return;
      }

      if (action === 'export') {
        exportUsers(currentActionUser.value?.id ? [currentActionUser.value.id] : selectedUsers.value);
        return;
      }

      currentAction.value = action;
      showActionModal.value = true;
    }

    const exportUsers = (data) => {
      store.dispatch('users/exportExcel', {
        users: data,
      }).finally(() => {
        clearCurrentAction()
      });

      message.info('Файл генерируется, пожалуйста, подождите')
    }

    const resetFilters = () => {
      store.dispatch('users/setUserFilters', {
        filters: {
          name: '',
          job_title: '',
          department: '',
          online_from: '',
          created_at: '',
          email: '',
          telephone: '',
          groups: [],
          without_group_only: false,
          without_limits_only: false,
          level_from: null,
          level_to: null,
        },
        filterString: null,
      });

      currentPage.value = 1;
      fetchUsers();
    }

    //сортировка
    const sortState = ref({
      field: null,
      order: null,
    });

    const handleTableChange = (pagination, filter, sorter) => {
      sortState.value = {
        field: sorter?.field ?? null,
        order: sorter?.order ?? null,
      };

      fetchUsers();
    }

    const fetchUsers = () => {
      tableLoading.value = true;

      store.dispatch("users/getStaffProducts", {
        special_staff: specialStaff.value?.length ? specialStaff.value : null,
        is_blocked: blockedStaff.value ?? null,
        per_page: entitiesPerPage.value,
        page: currentPage.value,
        sort_field: sortState.value.field,
        sort_direction:
            sortState.value.order === 'ascend'
                ? 'asc'
                : sortState.value.order === 'descend'
                    ? 'desc'
                    : null,
        ...filters.value,
        current_group: currentGroup.value === 'all' ?  null : currentGroup.value,
        course_id: currentProduct.value === 'all' ? null : currentProduct.value,
      }).then(() => {

        if (specialStaff.value?.length) {
          hidePagination.value = true;
          store.dispatch('users/clearSpecialStaff');
        } else if (hidePagination.value) {
          hidePagination.value = false;
        }

        store.dispatch('users/clearShowBlocked');

        tableLoading.value = false;
      });
    }

    // пагинация
    const retrieveEntitiesPerPage = () => {
      let storageValue = localStorage.getItem('perPage');
      entitiesPerPage.value = storageValue ? Number(storageValue) : 10;
    }

    const setEntitiesPerPage = (num) => {
      localStorage.setItem('perPage', num)
    }

    const handlePageChange = (current, perPage) => {
      if (entitiesPerPage.value !== perPage) {
        entitiesPerPage.value = perPage;
        setEntitiesPerPage(entitiesPerPage.value);
      }

      currentPage.value = current;
      fetchUsers();
    }

    const { isMobile } = useBreakpoints(767)

    const clearCurrentAction = () => {
      currentAction.value = null;
      actionToApply.value = null;

      showActionModal.value = false;
      manageGroupAccessUsers.value = [];
    }

    const fetchAfterSubmit = () => {
      clearCurrentAction();
      fetchUsers();
    }

    const remindAboutPassing = () => {
      if (currentActionUser.value) {
          const courses = staff.value.find((el) => el.id === currentActionUser.value.id).courses;

          courses.map((el) => {
            if (el.status !== 'finished' && el.external_id) {
              sendReminder(currentActionUser.value.id, el.external_id);
            }
          });

      } else {
        selectedUsers.value.map((id) => {
          const courses = staff.value.find((el) => el.id === id).courses;

          courses.map((el) => {
            if (el.status !== 'finished' && el.external_id) {
              sendReminder(id, el.external_id);
            }
          })
        });
      }

      clearCurrentAction();
      message.success('Напоминания отправлены');
    }

    const sendReminder = (userId, courseId) => {
      store.dispatch('company/remindAboutCourse', {
        userId: userId,
        courseId: courseId,
      });
    }

    const listState = computed(() => store.state.users.staffListState);

    onBeforeMount(() => {
      currentPage.value = listState.value.currentPage ?? 1
      sortState.value = {
        field: listState.value.sortField ?? null,
        order: listState.value.sortOrder ?? null,
      }

      store.dispatch("group/getGroups").then(() => {
        groups.value = allGroups.value.map((group) => {
          return {
            id: group.id,
            name: group.name,
          }
        });

        groupsLoading.value = false;
      });

      summaryIsLoading.value = true;

      store.dispatch('getCompanyActivity').then(() => {
        prepareProducts();
      }).finally(() => {
        summaryIsLoading.value = false;
      })

      retrieveEntitiesPerPage();
      fetchUsers();
    });

    watch(filters, () => {
          updateFilters();
        },
        { deep: true, immediate: true }
    );

    const subColumns = computed(() => [
      {
        title: 'Развивающее действие',
        dataIndex: 'name',
        width: 170,
        sorter: false,
      },
      {
        title: 'Дата выдачи',
        dataIndex: 'activated_at',
        sorter: false,
        width: 120,
      },
      {
        title: 'Статус',
        dataIndex: 'status',
        sorter: false,
        width: 100,
      },
      {
        title: 'Тип',
        dataIndex: 'type',
        sorter: false,
        width: 80,
      },
      {
        title: 'Завершить до',
        dataIndex: 'expires_at',
        sorter: false,
        width: 120,
      },
      {
        title: 'Прогресс',
        dataIndex: 'percent_completed',
        sorter: false,
        width: 140,
      },
      {
        title: 'Оценка',
        dataIndex: 'rate',
        sorter: false,
        width: 80,
      },
      {
        title: 'Пройдено',
        dataIndex: 'total_stages',
        sorter: false,
        width: 80,
      },
      {
        title: 'Текущий этап',
        dataIndex: 'current_stage',
        sorter: false,
        width: 180,
      },
      {
        title: 'Дата завершения',
        dataIndex: 'finished_at',
        sorter: false,
        width: 150,
      },
    ]);

    const expandableConfig = computed(() => ({
      rowExpandable: (record) =>
          Array.isArray(record.courses) && record.courses.length > 0,
      showExpandColumn: false,
      columnWidth: 30,
      expandFixed: true,
      expandIcon: ({ expanded, onExpand, record }) => {
          return h('span', {
            style: {
              display: 'inline-block',
              width: '12px',
              height: '12px',
            }
          });
    }}));

    const expandedRowKeys = computed(() => {
      return (staff.value || [])
          .filter(record => Array.isArray(record.courses) && record.courses.length > 0)
          .map(record => record.id);
    });

    const setSpecialDetailRouteAndRedirect = () => {
      store.dispatch('test/setSpecialDetailRoute', '/courses');
      router.push('/detailed');
    }

    const tableShell = ref(null);

    watch(tableLoading, async (loading) => {
      if (!loading) {
        await tableShell.value?.rebindScroll();
        await updateTableYScroll();
      }
    });

    watch(staff, async () => {
      await tableShell.value?.rebindScroll();
      await updateTableYScroll();
    }, { deep: true });

    watch(
        [currentPage, entitiesPerPage, sortState],
        () => {
          store.commit('users/setStaffListState', {
            currentPage: currentPage.value,
            sortField: sortState.value.field,
            sortOrder: sortState.value.order,
          })
        },
        { deep: true }
    )

    onBeforeRouteLeave((to) => {
      const isStillInStaff = to.path.startsWith('/staff')

      if (!isStillInStaff) {
        store.commit('users/clearStaffListState')
        store.dispatch('users/clearUserFilters')
        store.dispatch('users/clearSpecialStaff')
      }
    });

    return {
      router,
      NotFoundIcon,
      currentPage,
      entitiesPerPage,
      columns,
      actionToApply,
      actions,
      groups,
      onSelectChange,
      currentFiltersLine,
      tableLoading,
      showFilterModal,
      openFilterModal,
      updateFilters,
      filtersPopoverOpen,
      totalUsers,
      handlePageChange,
      showMobileFilterModal,
      handleTableChange,
      isMobile,
      showActionModal,
      modalActionLoading,
      statusError,
      actionButtonLabels,
      clearCurrentAction,
      manageGroupAccessUsers,
      showOrderForm,
      fetchAfterSubmit,
      resetFilters,
      clearCurrentUserAndAction,
      selectedUsers,
      currentAction,
      currentActionUser,
      tableData,
      getShortListColumns,
      hasMultipleOrderDates,
      emptySlot,
      summaryIsLoading,
      staff,
      handleAction,
      subColumns,
      expandableConfig,
      getExtendedColumns,
      expandedRowKeys,
      currentGroup,
      currentProduct,
      setSpecialDetailRouteAndRedirect,
      scrollX,
      scrollY,
      tableRef,
      tableScroll,
      summaryTableRef,
      summaryTableScroll,
    }
  }
}
</script>

<style scoped lang="scss">
.view-container {
  padding-top: 0;
  margin-top: 0;
}

.extended-filter-block {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    margin: 24px 20px;
    display: flex;
    column-gap: 25px;
    align-items: center;
    justify-content: space-between;
  }
}

.extended-filter-block h2 {
  font-size: 20px;
  margin-bottom: 0;
  font-weight: 600;
  line-height: 120%;
}

.extended-search-block-mobile {
  display: none;
  margin-right: 10px;

  @media(max-width: 768px) {
    display: block;
  }
}

:deep(.anticon-reload) {
  cursor: pointer;
}

:deep(.anticon-reload:hover) {
  color: var(--main-green) !important;
}

.orders-control {
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
  margin-bottom: 16px;
}

.search-outline-block {
  position: relative;
}

.dot {
  position: absolute;
  top: -1px;
  left: 11px;
  height: 5px;
  width: 5px;
  background-color: var(--color-error);
  border-radius: 50%;
}

h2 {
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
}

.pagination-block {
  margin-left: auto;
  margin-top: 20px;
}

:deep(.ant-table-thead >tr>th) {
  padding: 5px 10px !important;
}

:deep(.ant-table-tbody>tr:not(.ant-table-measure-row)>td) {
  padding: 10px 5px !important;
}

.inner-table {
  background: #fafafa;

  :deep(.ant-table-tbody) {
    background: #fafafa;
  }

  :deep(.ant-table-wrapper .ant-table-tbody >tr >td >.ant-table-wrapper:only-child .ant-table) {
    margin-block: 0 !important;
  }

  :deep(.ant-table.ant-table-empty) {
    margin-block: 0 !important;
  }

  :deep(thead th) {
    color: var(--grey-text);
    border-bottom: unset;
  }
}

.orders-table {
  position: relative;
}

.expand-header-gear {
  position: absolute;
  top: 8px;
  left: 10px;
  z-index: 1;
  font-size: 14px;
  color: var(--grey-text);
}

.user-link {
  cursor: pointer;
  color: var(--main-green);
}

.user-link:hover {
  color: var(--hover-color);
}

.order-button {
  margin-top: 16px;
}

.action-checkbox-wrapper {
  min-width: 200px;
}

.no-data-text {
  color: var(--main-font);
}

.order-button {
  @media(max-width: $mobile-breakpoint) {
    button {
      width: 100%;
    }
  }
}

.no-data-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 5px;
  padding: 24px;
}

.no-data-wrapper button {
  margin-top: 10px;
}

.no-data-wrapper button:hover {
  border-color: var(--main-green);
  color: var(--main-green);
}

:deep(.ant-btn-text.ant-dropdown-trigger) {
  color: lightgrey;
  height: auto !important;
  padding: 0 !important;
}

:deep(.ant-btn-text.ant-dropdown-trigger.ant-dropdown-open) {
  color: var(--main-font);
}

:deep(.ant-table-tbody .ant-dropdown-trigger) {
  height: auto !important;
}

.action-select-wrapper {
  min-width: 180px;

  @media (max-width: $mobile-breakpoint) {
    width: 100%;

    .ant-select {
      width: 100%;
    }
  }
}

:deep(.ant-table-thead >tr>th) {
  padding: 5px 10px !important;
}

:deep(.ant-table-tbody>tr:not(.ant-table-measure-row)>td) {
  padding: 10px 5px !important;
}

.inner-table {
  background: #fafafa;

  :deep(.ant-table-tbody) {
    background: #fafafa;
  }

  :deep(.ant-table-wrapper .ant-table-tbody >tr >td >.ant-table-wrapper:only-child .ant-table) {
    margin-block: 0 !important;
  }

  :deep(.ant-table.ant-table-empty) {
    margin-block: 0 !important;
  }

  :deep(thead th) {
    color: var(--grey-text);
    border-bottom: unset;
  }
}

.orders-table {
  position: relative;
}

.expand-header-gear {
  position: absolute;
  top: 8px;
  left: 10px;
  z-index: 1;
  font-size: 14px;
  color: var(--grey-text);
}

.user-link {
  cursor: pointer;
  color: var(--main-green);
}

.user-link:hover {
  color: var(--hover-color);
}

:deep(.ant-table-row-expand-icon-cell) {
  width: 20px !important;
  min-width: 20px !important;
  max-width: 20px !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
  text-align: center;
}

.inner-table {
  :deep(.ant-table-thead > tr > th) {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  :deep(.ant-table-tbody > tr > td) {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}

:deep(.product-course-table .ant-table-body) {
  overflow-y: auto !important;
}

.expiration-date-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 2px;
  flex-direction: row-reverse;
  line-height: 1.2;
}

.expiration-date-cell--interactive {
  cursor: pointer;
}
</style>
